import { EntityWithId } from 'src/types/baseEntities'

export const removeDuplicatesById = (entities: EntityWithId<number>[]) => {
    return entities.filter((entity, index, self) => self.findIndex(e => e.id === entity.id) === index)
}

export const removeDuplicatesByField = (entities: any[], field: string): any[] => {
    return entities.filter((entity, index, self) => self.findIndex(e => e[field] === entity[field]) === index)
}

export const arrayChunks = (array: any[], chunk_size: number) =>
    Array(Math.ceil(array.length / chunk_size))
        .fill(0)
        .map((_, index) => index * chunk_size)
        .map(begin => array.slice(begin, begin + chunk_size))

export const count = (array: any[] = [], countField: string) => {
    type countDict = { [key: string]: number }

    return array?.reduce((p: countDict, c) => {
        const field = c[countField]?.toString()
        if (!p.hasOwnProperty(field)) {
            p[field] = 0
        }
        p[field]++

        return p
    }, {})
}

export const sum = (array: any[] = [], groupField: string, sumField: string) => {
    type countDict = Record<string, number>

    return array?.reduce((p: countDict, c) => {
        const field = c[groupField]
        if (!p.hasOwnProperty(field)) {
            p[field] = 0
        }
        p[field] += c[sumField]

        return p
    }, {})
}

export const sumField = (array: any[] = [], sumField: string): number => {
    return array?.reduce((sum, curr) => {
        let increment = 0

        if (curr.hasOwnProperty(sumField)) increment = curr[sumField]

        return sum + increment
    }, 0)
}

export const groupBy = <T>(arr: T[] = [], keys: (keyof T)[]): { [key: string]: T[] } => {
    return arr.reduce((storage, item) => {
        const objKey = keys.map(key => `${item[key]}`).join(':')
        if (storage[objKey]) {
            storage[objKey].push(item)
        } else {
            storage[objKey] = [item]
        }

        return storage
    }, {} as { [key: string]: T[] })
}

export const groupBySum = <T>(array: T[] = [], groupFields: (keyof T)[], sumField: keyof T) => {
    const helper: Record<string, any> = {}

    //map to objects with selected fields
    const newArray = array.map((o: T) =>
        [...groupFields, sumField]

            //.filter((key: keyof T) => key in o)
            .reduce((obj2: Partial<T>, key) => ((obj2[key] = o[key]), obj2), {})
    )

    return newArray.reduce(function (r: Record<string, any>[], o: Partial<T>) {
        let key = ''
        groupFields.forEach((p: keyof T) => (key += o[p] + '-'))
        if (!helper[key]) {
            helper[key] = Object.assign({}, o) //create a copy of object
            r.push(helper[key])
        } else {
            helper[key][sumField] += o[sumField]
        }

        return r
    }, [])
}
